<template>
  <div class="card-container">
    <div class="c-header-container">
      <div class="c-header">
        SYSTEMS WITH ACTIVE ALERT
      </div>
      <div class="c-date-container">
        <div class="c-date">
          {{ customDateFilter(todayDate, dateFormat) }}
        </div>
      </div>
    </div>
    <div class="c-number-container">
      <img
        v-if="loadingTableData"
        src="@shared/assets/img/general/loading-white.svg"
        class="loading"
        alt="loading"
      >
      <div
        v-else-if="cardData.count === 0"
        class="sac__font-14 f-white n40"
      >
        No system with active alert
      </div>
      <div
        v-else
        class="sac__font-18 med f-white"
      >
        {{ cardData.count }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import systemHealthMixin from '@shared/mixins/systemHealthMixin';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'TodayAlert',
  mixins: [systemHealthMixin, unitPreferencesMixin],
  data() {
    const todayDate = moment().format('MMM D, YYYY');
    return {
      loading: true,
      loadingDiff: true,
      countLabel: '',
      todayDate,
    };
  },
  computed: {
    cardData() {
      let count = 0;
      this.tableData.forEach((t) => {
        const {
          alerts,
        } = t;
        const urgent = alerts.reduce((acc, alert) => {
          let uA = acc;
          if (alert.severity === 'Urgent') {
            uA = true;
          }
          return uA;
        }, false);
        if (urgent) {
          count += 1;
        }
      });
      let countLabel = 'Systems with active alert';
      if (count === 1) {
        countLabel = 'System with active alert';
      }

      const data = {
        count,
        countLabel,
      };

      return data;
    },
  },
};
</script>
